import { useMemo } from 'react';
import { createOption } from '@mews-commander/ui';
import { useLocalizeText } from '@mews/framework';

export const useGetSelectOptions = (options: object) => {
    const localizeText = useLocalizeText();

    return useMemo(
        () =>
            Object.entries(options).map(([key, textKey]) =>
                createOption({
                    value: key,
                    label: localizeText({ textKey }),
                })
            ),
        [localizeText, options]
    );
};
